// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.full-page-container {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  width: 70vw;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
  min-height: 40vh;
}

.add-button {
  background-color: #1B3E78;
  color: #fff;
  border-radius: 5px;
  border: 2px solid rgba(231, 231, 231, 0.5);
}

.add-button:hover {
  background-color: #0CAD99;
}

.lists-table-container {
  background-color: white;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: center;
  overflow: wrap;
  position: relative;
}

.wrapper {
  width: 70vw;
  margin: auto auto 15vh auto;
  padding: 0;
  background: #fff;
  color: black;
}

.echelon {
  border-radius: 10px;
  margin: 10px;
  background-color: white;
  overflow: wrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  max-height: 100%; /* Ensure it doesn't cut off content */
}

.echelon:hover {
  box-shadow: 0 0 20px rgba(12, 173, 153, 0.8);
  transition: all 0.3s;
}
.echelon:hover .echelon-header {
  background-color: rgba(12, 173, 153, 0.3);
  transition: all 0.3s;
}
.echelon:hover .echelon-footer {
  background-color: rgba(12, 173, 153, 0.3);
  transition: all 0.3s;
}

.echelon-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;
  overflow: auto; /* Allow scrolling if content overflows */
}

.echelon-expanded-body {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;
  overflow: auto; /* Allow scrolling if content overflows */
}

.centered-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.echelon-content-container {
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 600px;
}
.echelon-content-container div {
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
}
.echelon-content-container app-chart-wrapper {
  width: 100%;
}

.echelon-header {
  position: relative;
  padding-right: 20px;
  padding-left: 15px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background-color: #1B3E78;
  color: #fff;
}
.echelon-header p {
  color: #fff;
}

.echelon-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #2D2D2A;
  background-color: #e7e7e7;
}

.echelon-footer p {
  color: #2D2D2A;
  font-size: 12px;
}

.chart {
  animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

p {
  font-weight: bold;
  font-size: 20px;
  text-align: justify;
  color: #e7e7e7;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 0px;
}

h1 {
  justify-content: center;
  align-items: center;
}

.expand-button {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.material-symbols-outlined {
  color: #1B3E78;
}

.material-symbols-outlined:hover {
  color: #0CAD99;
  transition: color 0.1s ease-in-out, background-color 0.5s ease-in-out;
}

.material-symbols-outlined:active {
  background-color: #3792BF;
  color: white;
}

.fade {
  animation: fade-in-fwd 0.5s ease-in-out forwards, slide-out-left 1s ease-in-out 3s forwards;
}

.no-results {
  margin: 30px;
}

.list-details-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.list-details {
  display: flex;
  flex-direction: column;
}

.owner, .creation-date, .last-modified {
  font-size: 14px;
  color: #555;
}

.list-name {
  font-size: 1.5rem;
  color: #333;
  margin: 0;
}

.request-button {
  background-color: #1B3E78;
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 15px 30px;
  cursor: pointer;
  margin-left: 10px;
}

.request-button-secondary {
  background-color: #0CAD99;
  color: #fff;
  border: none;
  border-radius: 25px;
  padding: 15px 30px;
  cursor: pointer;
  margin-left: 10px;
}

.button-container {
  display: flex;
  flex-direction: column; /* Makes sure buttons are stacked vertically */
  align-items: center; /* Center buttons horizontally */
  gap: 10px; /* Adds spacing between buttons */
}

.request-button:hover {
  background-color: #0CAD99;
}

.request-button-secondary:hover {
  background-color: #1B3E78;
}

.visualizations-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 50vw;
  max-width: 900px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.visualization-card {
  background-color: white;
  border: 1px solid rgba(231, 231, 231, 0.5);
  border-radius: 8px;
  margin: 10px 0;
  padding: 15px;
  width: 50vw;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}
.visualization-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.visualization-card .remove-btn {
  display: none; /* Hide the button by default */
}
.visualization-card:hover .remove-btn {
  display: block; /* Show the button when the card is hovered over */
}

p {
  font-size: 16px;
  color: #2D2D2A;
  margin: 20px 0;
  text-align: center;
}

.remove-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #1B3E78;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  z-index: 2;
  cursor: pointer;
}

app-lists-table {
  width: 100%;
}

@media (max-width: 1300px) {
  .full-page-container {
    width: 69vw;
  }
  .echelon-content-container {
    width: 60vw;
  }
  .wrapper {
    display: block;
    overflow: wrap;
    width: 71vw;
  }
  .visualizations-container .visualization-card {
    width: 70vw;
  }
  .lists-table-container {
    min-width: 80vw;
    max-width: 99vw;
  }
  .echelon-body, .echelon-expanded-body {
    flex-direction: column;
    overflow-y: scroll; /* Allow scrolling if content overflows */
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
  }
  .echelon {
    max-height: 100px;
    width: 69vw;
  }
  .echelon-header, .echelon-footer {
    display: flex;
    flex-direction: row;
  }
}
@media (max-width: 768px) {
  .full-page-container {
    width: 78vw;
  }
  h1 {
    margin: 30px;
  }
  .wrapper {
    width: 85vw;
    margin: 5vh auto;
    overflow: wrap;
  }
  table {
    width: 100%;
  }
  th {
    width: 87.3vw;
  }
  .echelon {
    width: 85vw;
    margin: 10px auto;
    flex-direction: column;
    max-height: none; /* Ensure it doesn't cut off content */
    overflow: wrap;
  }
  .echelon-header, .echelon-footer {
    flex-direction: row;
  }
  .echelon-body, .echelon-expanded-body {
    flex-direction: column;
    overflow-y: scroll; /* Allow scrolling if content overflows */
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
  }
  .echelon-body::-webkit-scrollbar, .echelon-expanded-body::-webkit-scrollbar {
    display: none; /* For Chrome, Safari, and Opera */
  }
  .list-details-container {
    flex-direction: column;
    align-items: flex-start;
  }
  .visualizations-container {
    width: 80vw;
    max-width: 80vw;
  }
  .visualizations-container .visualization-card {
    width: 80vw;
  }
  .list-details {
    font-size: 14px;
  }
  .list-name {
    font-size: 1.2rem;
  }
  .owner, .creation-date, .last-mod .owner,
  .creation-date, .last-modified {
    font-size: 12px;
  }
  .request-button, request-button-secondary {
    padding: 10px 20px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./src/app/lists/saved-charts/saved-charts.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss"],"names":[],"mappings":"AAAA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;ACAF;ADEE;EACE,4BAAA;ACAJ;ADEI;EACE,YAAA;ACAN;;AFZA,sBAAA;AGME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ADUJ;ACPM;EACE,sHAAA;ADSR;ACLI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ADON;ACJI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ADMN;ACHI;EACE,mBAAA;EACA,sBAAA;ADKN;;ACEE;EACE,qCAAA;ADCJ;ACEE;EACE,0BAAA;ADAJ;;ACME;EACE,0BAAA;ADHJ;ACME;EACE,uFAAA;ADJJ;;AEzDA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AF0DA;;AEvDA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AF0DJ;;AEtDA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AFuDJ;;AElDA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AFmBR;;AEbA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AFwEb;;AEXA;EAAa,YAAA;AFeb;;AEdA;EAAO,SAAA;EAAW,iDAAA;AFmBlB;;AEhBA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AFiBJ;AEfI;EACI,YAAA;EACA,SAAA;AFiBR;;AEdA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AFiBF;;AEdA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AFiGb;AEfI;EACI,cAnFK;AFoGb;;AEbA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AF4Ff;AEdE;EACE,cA/EW;AF+Ff;;AEZA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AFeJ;;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHsKF;AGnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHqKF;AGlKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHoKF;AGjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHmKF;AGhKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHkKF;AG/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHiKF;AG9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHgKF;AG7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH+JF;AG5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AH8JF;AG3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH6JF;AG1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH4JF;AGzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH2JF;AGxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH0JF;AGvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AHyJF;AGtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHwJF;AGrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHuJF;AGpJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHsJF;AGnJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHqJF;AIzQA;;;;;uBAAA;ADPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHwRF;AGrRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AHuRF;AGpRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHsRF;AGnRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;AHqRF;AGlRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AHoRF;AGjRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AHmRF;AGhRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AHkRF;AG/QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHiRF;AG9QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AHgRF;AG7QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AH+QF;AG5QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AH8QF;AG3QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AH6QF;AG1QA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AH4QF;AGzQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AH2QF;AGxQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AH0QF;AGvQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AHyQF;AGtQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;AHwQF;AGrQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AHuQF;AI3XA;;;;;uBAAA;AJAA;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAmYJ;;AAhYA;EACI,yBITQ;EJUR,WAAA;EACA,kBAAA;EACA,0CAAA;AAmYJ;;AAhYA;EACI,yBIjBS;AJoZb;;AA/XA;EACI,uBAAA;EAGA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EAGA,cAAA;EACA,kBAAA;AA8XJ;;AA3XA;EACI,WAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AA8XJ;;AA3XA;EACI,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,0CAAA;EACA,gBAAA,EAAA,sCAAA;AA8XJ;;AA3XA;EACI,4CAAA;EACA,oBAAA;AA8XJ;AA5XI;EACI,yCAAA;EACA,oBAAA;AA8XR;AA3XI;EACI,yCAAA;EACA,oBAAA;AA6XR;;AAzXA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA,EAAA,yCAAA;AA4XJ;;AAzXA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA,EAAA,yCAAA;AA4XJ;;AAzXA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AA4XJ;;AAzXA;EACI,wBAAA;EAAA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA4XJ;AA1XI;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AA4XR;AAzXI;EACI,WAAA;AA2XR;;AAvXA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBItHQ;EJuHR,WAAA;AA0XJ;AAxXI;EACI,WAAA;AA0XR;;AAtXA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cE5GS;EF6GT,yBE/Ec;AFwclB;;AAtXA;EACI,cEjHS;EFkHT,eAAA;AAyXJ;;AAtXA;EACI,gEAAA;EACA,wEAAA;AAyXJ;;AAtXA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cEhGc;EFiGd,gBAAA;EACA,iBAAA;EACA,iBAAA;AAyXJ;;AAtXA;EACI,uBAAA;EACA,mBAAA;AAyXJ;;AAtXA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAyXJ;;AAtXA;EACI,cIjKS;AJ0hBb;;AArXA;EACI,cIrKa;EJsKb,qEAAA;AAwXJ;;AArXA;EACI,yBIzKM;EJ0KN,YAAA;AAwXJ;;AArXA;EACI,2FAAA;AAwXJ;;AArXA;EACI,YAAA;AAwXJ;;AArXA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAwXJ;;AArXA;EACI,aAAA;EACA,sBAAA;AAwXJ;;AArXA;EACI,eAAA;EACA,WAAA;AAwXJ;;AArXA;EACI,iBAAA;EACA,WAAA;EACA,SAAA;AAwXJ;;AArXA;EACI,yBI/MS;EJgNT,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAwXJ;;AAtXA;EACE,yBIvNe;EJwNf,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAyXF;;AAvXA;EACE,aAAA;EACA,sBAAA,EAAA,8CAAA;EACA,mBAAA,EAAA,gCAAA;EACA,SAAA,EAAA,iCAAA;AA0XF;;AAxXA;EACI,yBItOa;AJimBjB;;AAzXA;EACE,yBI1OW;AJsmBb;;AAzXA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;AA4XJ;;AA1XI;EACI,uBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,wCAAA;EACA,0BAAA;AA6XR;AA3XQ;EACI,2BAAA;EACA,yCAAA;AA6XZ;AA1XQ;EACI,aAAA,EAAA,+BAAA;AA4XZ;AAzXQ;EACI,cAAA,EAAA,kDAAA;AA2XZ;;AAtXI;EACI,eAAA;EACA,cEnQK;EFoQL,cAAA;EACA,kBAAA;AAyXR;;AArXA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBI9RS;EJ+RT,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAwXJ;;AAtXA;EACI,WAAA;AAyXJ;;AArXA;EAEI;IAEA,WAAA;EAsXF;EAnXE;IACI,WAAA;EAqXN;EAnXE;IACI,cAAA;IACA,cAAA;IACA,WAAA;EAqXN;EAlXM;IACI,WAAA;EAoXV;EAhXE;IACI,eAAA;IACA,eAAA;EAkXN;EAhXE;IACI,sBAAA;IACA,kBAAA,EAAA,yCAAA;IACA,qBAAA,EAAA,gBAAA;IACA,wBAAA,EAAA,mCAAA;EAkXN;EA/WE;IACI,iBAAA;IACA,WAAA;EAiXN;EA9WE;IACI,aAAA;IACA,mBAAA;EAgXN;AACF;AA3WA;EAEI;IAEI,WAAA;EA2WN;EAvWE;IACI,YAAA;EAyWN;EAlWE;IACI,WAAA;IACA,gBAAA;IACA,cAAA;EAoWN;EAjWE;IACI,WAAA;EAmWN;EAhWE;IACI,aAAA;EAkWN;EA/VE;IACI,WAAA;IACA,iBAAA;IACA,sBAAA;IACA,gBAAA,EAAA,sCAAA;IACA,cAAA;EAiWN;EA7VE;IACI,mBAAA;EA+VN;EA3VF;IACI,sBAAA;IACA,kBAAA,EAAA,yCAAA;IACA,qBAAA,EAAA,gBAAA;IACA,wBAAA,EAAA,mCAAA;EA6VF;EA1VF;IACI,aAAA,EAAA,kCAAA;EA4VF;EAzVE;IACI,sBAAA;IACA,uBAAA;EA2VN;EAxVE;IACI,WAAA;IACA,eAAA;EA0VN;EAvVE;IACI,WAAA;EAyVN;EAtVE;IACI,eAAA;EAwVN;EArVE;IACI,iBAAA;EAuVN;EApVE;;IAEI,eAAA;EAsVN;EAnVE;IACI,kBAAA;IACA,eAAA;EAqVN;AACF","sourcesContent":["/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import '/src/styles.scss';\n@import \"placeholders/flexboxes\";\n@import \"placeholders/fonts\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n\n.full-page-container {\n    background-color: white;\n    border-radius: 15px;\n    padding: 20px;\n    width: 70vw;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    position: relative;\n    margin-bottom: 10px;\n    min-height: 40vh;\n}\n\n.add-button{\n    background-color:  $dark-text;\n    color: #fff;\n    border-radius: 5px;\n    border: 2px solid rgba($theme-lightgray, 0.5);\n}\n\n.add-button:hover {\n    background-color: $accent-btn;\n\n}\n\n.lists-table-container {\n    background-color: white;\n    // min-width: 44vw;\n    // max-width: 69vw;\n    width: 100%;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    // align-items: flex-start;\n    // box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n    overflow: wrap;\n    position: relative;\n}\n\n.wrapper {\n    width: 70vw;\n    margin: auto auto 15vh auto;\n    padding: 0;\n    background: #fff;\n    color: black;\n}\n\n.echelon {\n    border-radius: 10px;\n    margin: 10px;\n    background-color: white;\n    overflow: wrap;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);\n    max-height: 100%; /* Ensure it doesn't cut off content */\n}\n\n.echelon:hover {\n    box-shadow: 0 0 20px rgba($theme-contrast, 0.8);\n    transition: all 0.3s;\n\n    .echelon-header {\n        background-color: rgba($theme-contrast, 0.3);\n        transition: all 0.3s;\n    }\n\n    .echelon-footer {\n        background-color: rgba($theme-contrast, 0.3);\n        transition: all 0.3s;\n    }\n}\n\n.echelon-body {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    flex-direction: row;\n    overflow: auto; /* Allow scrolling if content overflows */\n}\n\n.echelon-expanded-body {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    flex-direction: row;\n    overflow: auto; /* Allow scrolling if content overflows */\n}\n\n.centered-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n\n.echelon-content-container {\n    height: fit-content;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 600px;\n\n    div {\n        width: 100%;\n        margin-left: 5px;\n        margin-right: 5px;\n    }\n\n    app-chart-wrapper {\n        width: 100%;\n    }\n}\n\n.echelon-header {\n    position: relative;\n    padding-right: 20px;\n    padding-left: 15px;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n    background-color:  $dark-text;\n    color: #fff;\n\n    p {\n        color: #fff;\n    }\n}\n\n.echelon-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    color: $theme-back;\n    background-color: $theme-lightgray;\n}\n\n.echelon-footer p {\n    color: $theme-back;\n    font-size: 12px;\n}\n\n.chart {\n    animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    -webkit-animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\np {\n    font-weight: bold;\n    font-size: 20px;\n    text-align: justify;\n    color: $theme-lightgray;\n    margin-left: 5px;\n    margin-right: 5px;\n    padding-left: 0px;\n}\n\nh1 {\n    justify-content: center;\n    align-items: center;\n}\n\n.expand-button {\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n}\n\n.material-symbols-outlined {\n    color: $theme-main;\n}\n\n\n.material-symbols-outlined:hover {\n    color: $theme-contrast;\n    transition: color 0.1s ease-in-out, background-color 0.5s ease-in-out;\n}\n\n.material-symbols-outlined:active {\n    background-color: $theme-1;\n    color: white;\n}\n\n.fade {\n    animation: fade-in-fwd 0.5s ease-in-out forwards, slide-out-left 1s ease-in-out 3s forwards;\n}\n\n.no-results {\n    margin: 30px;\n}\n\n.list-details-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.list-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.owner, .creation-date, .last-modified {\n    font-size: 14px;\n    color: #555;\n}\n\n.list-name {\n    font-size: 1.5rem;\n    color: #333;\n    margin: 0;\n}\n\n.request-button {\n    background-color: $theme-main;\n    color: #fff;\n    border: none;\n    border-radius: 25px;\n    padding: 15px 30px;\n    cursor: pointer;\n    margin-left: 10px;\n}\n.request-button-secondary {\n  background-color: $theme-contrast;\n  color: #fff;\n  border: none;\n  border-radius: 25px;\n  padding: 15px 30px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n.button-container {\n  display: flex;\n  flex-direction: column; /* Makes sure buttons are stacked vertically */\n  align-items: center;     /* Center buttons horizontally */\n  gap: 10px;               /* Adds spacing between buttons */\n}\n.request-button:hover {\n    background-color: $theme-contrast;\n}\n.request-button-secondary:hover {\n  background-color: $theme-main;\n}\n\n.visualizations-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    width: 50vw;\n    max-width: 900px;\n    margin: 0 auto;\n    background-color: #f9f9f9;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n    .visualization-card {\n        background-color: white;\n        border: 1px solid rgba($theme-lightgray, 0.5);\n        border-radius: 8px;\n        margin: 10px 0;\n        padding: 15px;\n        width: 50vw;\n        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n        transition: transform 0.2s;\n\n        &:hover {\n            transform: translateY(-5px);\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n        }\n\n        .remove-btn {\n            display: none; /* Hide the button by default */\n        }\n\n        &:hover .remove-btn {\n            display: block; /* Show the button when the card is hovered over */\n        }\n\n    }\n\n    p {\n        font-size: 16px;\n        color: $theme-back;\n        margin: 20px 0;\n        text-align: center;\n    }\n\n\n.remove-btn {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: $theme-main;\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    z-index: 2;\n    cursor: pointer;\n}\napp-lists-table{\n    width: 100%;\n}\n\n\n@media (max-width: 1300px) {\n\n    .full-page-container {\n\n    width: 69vw;\n\n    }\n    .echelon-content-container {\n        width: 60vw;\n    }\n    .wrapper {\n        display: block;\n        overflow: wrap;\n        width: 71vw;\n    }\n    .visualizations-container {\n        .visualization-card {\n            width: 70vw;\n        }\n    }\n\n    .lists-table-container {\n        min-width: 80vw;\n        max-width: 99vw;\n    }\n    .echelon-body, .echelon-expanded-body {\n        flex-direction: column;\n        overflow-y: scroll; /* Allow scrolling if content overflows */\n        scrollbar-width: none; /* For Firefox */\n        -ms-overflow-style: none; /* For Internet Explorer and Edge */\n    }\n\n    .echelon {\n        max-height: 100px;\n        width: 69vw;\n    }\n\n    .echelon-header, .echelon-footer {\n        display: flex;\n        flex-direction: row;\n        // width: 100%;\n    //    justify-content: space-between;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .full-page-container {\n\n        width: 78vw;\n\n    }\n\n    h1{\n        margin: 30px;\n    }\n    // .full-page-container {\n    //     width: 95vw;\n    //     padding: 10px;\n    // }\n\n    .wrapper {\n        width: 85vw;\n        margin: 5vh auto;\n        overflow: wrap;\n\n    }\n    table {\n        width: 100%;\n    }\n\n    th{\n        width: 87.3vw;\n    }\n\n    .echelon {\n        width: 85vw;\n        margin: 10px auto;\n        flex-direction: column;\n        max-height: none; /* Ensure it doesn't cut off content */\n        overflow: wrap;\n    }\n\n\n    .echelon-header, .echelon-footer {\n        flex-direction: row;\n        // padding: 10px;\n    }\n\n.echelon-body, .echelon-expanded-body {\n    flex-direction: column;\n    overflow-y: scroll; /* Allow scrolling if content overflows */\n    scrollbar-width: none; /* For Firefox */\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n}\n\n.echelon-body::-webkit-scrollbar, .echelon-expanded-body::-webkit-scrollbar {\n    display: none; /* For Chrome, Safari, and Opera */\n}\n\n    .list-details-container {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .visualizations-container {\n        width: 80vw;\n        max-width: 80vw;\n    }\n\n    .visualizations-container .visualization-card {\n        width: 80vw;\n    }\n\n    .list-details {\n        font-size: 14px;\n    }\n\n    .list-name {\n        font-size: 1.2rem;\n    }\n\n    .owner, .creation-date, .last-mod\n    .owner, .creation-date, .last-modified {\n        font-size: 12px;\n    }\n\n    .request-button, request-button-secondary {\n        padding: 10px 20px;\n        font-size: 14px;\n    }\n}\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
